import { render } from "./PrivateIcon.vue?vue&type=template&id=2addd64c"
import script from "./PrivateIcon.vue?vue&type=script&lang=js"
export * from "./PrivateIcon.vue?vue&type=script&lang=js"
script.render = render

export default script